import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

const NAV = [
  { path: '/',         label: 'التفريغ',    icon: '🎙️', roles: ['admin','supervisor','team'] },
  { path: '/folders',  label: 'المجلّدات',  icon: '📂', roles: ['admin','supervisor','team'] },
  { path: '/tags',     label: 'الوسوم',     icon: '🏷️', roles: ['admin','supervisor','team'] },
  { path: '/users',    label: 'المستخدمون', icon: '👤', roles: ['admin','supervisor'] },
  { path: '/webhooks', label: 'Webhooks',   icon: '🔗', roles: ['admin'] },
  { path: '/settings', label: 'الإعدادات',  icon: '⚙️', roles: ['admin'] },
  { path: '/profile',  label: 'ملفّي',     icon: '👤', roles: ['admin','supervisor','team'] },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const { theme, toggle: toggleTheme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('sidebar-collapsed') === '1');
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => { localStorage.setItem('sidebar-collapsed', collapsed ? '1' : '0'); }, [collapsed]);
  useEffect(() => { setDrawerOpen(false); }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  const visibleNav = NAV.filter(n => n.roles.includes(user?.role));
  const bottomTabsRef = useRef(null);
  const activeTabRef  = useRef(null);
  const activeBottomIdx = (() => {
    const idx = visibleNav.findIndex(n => n.path === '/' ? location.pathname === '/' : location.pathname.startsWith(n.path));
    return idx === -1 ? 0 : idx;
  })();
  useEffect(() => {
    const el = activeTabRef.current; const strip = bottomTabsRef.current;
    if (!el || !strip) return;
    const elBox = el.getBoundingClientRect(); const stripBox = strip.getBoundingClientRect();
    const delta = (elBox.left + elBox.width / 2) - (stripBox.left + stripBox.width / 2);
    if (Math.abs(delta) > 4) strip.scrollBy({ left: delta, behavior: 'smooth' });
  }, [activeBottomIdx]);

  return (
    <div className={`layout ${collapsed ? 'collapsed' : ''} ${drawerOpen ? 'drawer-open' : ''}`}>
      <div className="drawer-backdrop" onClick={() => setDrawerOpen(false)} />

      <aside className="sidebar">
        <div className="sidebar-header" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src={`${process.env.PUBLIC_URL || ''}/logo-mark.svg`} alt="" style={{ width: 32, height: 32, flexShrink: 0 }}/>
          {!collapsed && <h2 style={{ margin: 0, fontSize: 18 }}>منصّة مُفرِّغ</h2>}
          <button className="btn-icon sidebar-collapse-btn" onClick={() => setCollapsed(!collapsed)} title={collapsed ? 'توسيع' : 'طي'}>
            {collapsed ? '◀' : '▶'}
          </button>
          <button className="btn-icon drawer-close-btn" onClick={() => setDrawerOpen(false)} title="إغلاق" aria-label="إغلاق القائمة">✕</button>
        </div>
        <nav>
          {visibleNav.map(n => (
            <NavLink key={n.path} to={n.path} end={n.path === '/'}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              title={collapsed ? n.label : ''}>
              <span className="nav-icon">{n.icon}</span>
              {!collapsed && <span>{n.label}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          {!collapsed && <span className="user-name">{user?.name}</span>}
          <button className="btn-icon" onClick={() => { logout(); navigate('/login'); }} title="تسجيل خروج">🚪</button>
        </div>
      </aside>

      <main className="main-content">
        <header className="topbar">
          <button className="btn-icon mobile-menu-btn" onClick={() => setDrawerOpen(true)} aria-label="فتح القائمة">☰</button>
          <div className="mobile-title">منصّة مُفرِّغ</div>
          <div className="topbar-right" />
          <div className="topbar-left">
            <button className="btn-icon" onClick={toggleTheme} title={theme === 'dark' ? 'وضع النهار' : 'وضع الليل'}>
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>
            <span className="user-badge">{user?.name}</span>
          </div>
        </header>
        <div className="content-area">{children}</div>
      </main>

      <nav className="bottom-tabs" ref={bottomTabsRef}>
        <div className="bottom-tabs-strip">
          {visibleNav.map((n, i) => (
            <NavLink key={n.path} to={n.path} end={n.path === '/'}
              ref={i === activeBottomIdx ? activeTabRef : null}
              className={({ isActive }) => `bottom-tab ${isActive ? 'active' : ''}`}
              aria-label={n.label}>
              <span className="bottom-tab-icon">{n.icon}</span>
              <span className="bottom-tab-label">{n.label}</span>
            </NavLink>
          ))}
        </div>
        <div className="bottom-tabs-fade bottom-tabs-fade-start" aria-hidden="true" />
        <div className="bottom-tabs-fade bottom-tabs-fade-end" aria-hidden="true" />
      </nav>
    </div>
  );
}
